import React from "react";
import { observer } from "mobx-react";
import { TenantTypeUpdateStore } from "../../store";
import { TenantTypeUpdateForm } from "./TenantTypeUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type TenantTypeUpdateProps = {
  tenantTypeUpdateStore: TenantTypeUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TenantTypeUpdate: React.FC<TenantTypeUpdateProps> = observer(
  ({ tenantTypeUpdateStore, showToolbox = true, showSaveFooter }) => {
    return (
      <>
        <SavingOverlay open={tenantTypeUpdateStore.isSaving} />
        <OutdatedAfterSaveNotice
          open={tenantTypeUpdateStore.savedButOutdated}
          onReload={() => tenantTypeUpdateStore.reloadTenantType()}
          reloadDisabled={tenantTypeUpdateStore.isProcessing}
        />
        <TenantTypeUpdateForm
          tenantTypeUpdateStore={tenantTypeUpdateStore}
          name_esError={tenantTypeUpdateStore.errors.name_es?.message}
          onName_esChange={(value: string) => {
            tenantTypeUpdateStore.setName_esValue(value);
          }}
          name_es={tenantTypeUpdateStore.entityValues.name_es}
          name_enError={tenantTypeUpdateStore.errors.name_en?.message}
          onName_enChange={(value: string) => {
            tenantTypeUpdateStore.setName_enValue(value);
          }}
          name_en={tenantTypeUpdateStore.entityValues.name_en}
          name_ptError={tenantTypeUpdateStore.errors.name_pt?.message}
          onName_ptChange={(value: string) => {
            tenantTypeUpdateStore.setName_ptValue(value);
          }}
          name_pt={tenantTypeUpdateStore.entityValues.name_pt}
          description_esError={
            tenantTypeUpdateStore.errors.description_es?.message
          }
          onDescription_esChange={(value: string) => {
            tenantTypeUpdateStore.setDescription_esValue(value);
          }}
          description_es={tenantTypeUpdateStore.entityValues.description_es}
          description_enError={
            tenantTypeUpdateStore.errors.description_en?.message
          }
          onDescription_enChange={(value: string) => {
            tenantTypeUpdateStore.setDescription_enValue(value);
          }}
          description_en={tenantTypeUpdateStore.entityValues.description_en}
          description_ptError={
            tenantTypeUpdateStore.errors.description_pt?.message
          }
          onDescription_ptChange={(value: string) => {
            tenantTypeUpdateStore.setDescription_ptValue(value);
          }}
          description_pt={tenantTypeUpdateStore.entityValues.description_pt}
          showToolbox={showToolbox}
          showSaveFooter={showSaveFooter}
          saving={tenantTypeUpdateStore.saveDisabled}
          onSave={() => tenantTypeUpdateStore.saveTenantType()}
          onCancel={() => tenantTypeUpdateStore.cancelTenantType()}
        />
        <ErrorDialog
          open={tenantTypeUpdateStore.errorDialogOpened}
          title={tenantTypeUpdateStore.errorTitle}
          description={tenantTypeUpdateStore.errorDescription}
          onClose={() => tenantTypeUpdateStore.closeErrorDialog()}
        />
        <ConfirmCancelDialog
          open={tenantTypeUpdateStore.confirmDialogOpened}
          title={tenantTypeUpdateStore.confirmDialogTitle}
          description={tenantTypeUpdateStore.confirmDialogDescription}
          onConfirm={() => tenantTypeUpdateStore.executeConfirmedAction()}
          onCancel={() => tenantTypeUpdateStore.closeConfirmDialog()}
        />
      </>
    );
  }
);
